import {
    DESKTOP_BREAKPOINT_MIN,
    OLD_MOBILE_BREAKPOINT_MAX,
    DESKTOP_LG_BREAKPOINT_MIN,
} from '../config/consts';

const MOBILE_RESOLUTION = 'mobile';
const TABLET_RESOLUTION = 'tablet';
const DESKTOP_RESOLUTION = 'desktop';
const SMALL_DESKTOP_RESOLUTION = 'small-desktop';
const LARGE_DESKTOP_RESOLUTION = 'large-desktop';

const getResolution = () => {
    if (window.innerWidth > OLD_MOBILE_BREAKPOINT_MAX) {
        return DESKTOP_RESOLUTION;
    }
    if (window.innerWidth >= DESKTOP_BREAKPOINT_MIN) {
        return TABLET_RESOLUTION;
    }
    return MOBILE_RESOLUTION;
};

const getDesktopResolution =
    window.innerWidth > DESKTOP_LG_BREAKPOINT_MIN
        ? LARGE_DESKTOP_RESOLUTION
        : SMALL_DESKTOP_RESOLUTION;

export const isNotDesktop = () => getResolution() !== DESKTOP_RESOLUTION;
export const isDesktop = () => getResolution() === DESKTOP_RESOLUTION;
export const isMobile = () => getResolution() === MOBILE_RESOLUTION;
export const isTablet = () => getResolution() === TABLET_RESOLUTION;
export const isSmallDesktop = () =>
    getResolution() === DESKTOP_RESOLUTION && getDesktopResolution === SMALL_DESKTOP_RESOLUTION;
export const isLargeDesktop = () =>
    getResolution() === DESKTOP_RESOLUTION && getDesktopResolution === LARGE_DESKTOP_RESOLUTION;
